import { GiftOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { useState } from "react";
import { Breadcrumb } from "antd";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import Navbar from "../Menu/Navbar";
import Footer from "./Sections/Footer";

const OffersDetails = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const { name, summary, details, image } = location.state || {};
  const [failedImage, setFailedImage] = useState<string | null>(null);
  const imageSource = typeof image === "string" ? image.trim() : "";
  const usePlaceholder = !imageSource || failedImage === imageSource;
  const isRtl = i18n.dir() === "rtl";
  const hasOffer = Boolean(name || summary || details || image);

  return (
    <>
      <Navbar type="internal" />
      <main className="main ac-offer-detail ac--font-expo" dir={i18n.dir()}>
        <div className="container">
          <nav className="ac-offer-detail__breadcrumbs" aria-label={t("offerDetail.breadcrumbs")}>
            <Breadcrumb
              separator={isRtl ? <IoIosArrowBack /> : <IoIosArrowForward />}
              items={[
                { title: <Link to="/">{t("menu.home")}</Link> },
                { title: <Link to="/offers">{t("menu.offers")}</Link> },
                { title: <span aria-current="page">{name || t("offerDetail.details")}</span> },
              ]}
            />
          </nav>

          {hasOffer ? (
            <article>
              <header className="ac-offer-detail__heading">
                <span className="ac-offer-detail__eyebrow">
                  <GiftOutlined aria-hidden="true" />
                  {t("menu.offers")}
                </span>
                <h1>{name || t("offerDetail.details")}</h1>
                {summary && <p>{summary}</p>}
              </header>

              <div className="ac-offer-detail__layout">
                <div className={`ac-offer-detail__media${usePlaceholder ? " ac-offer-detail__media--placeholder" : ""}`}>
                  <img
                    src={usePlaceholder ? "/assets/imgs/offres/banner.png" : imageSource}
                    alt={usePlaceholder ? "" : name || t("offerDetail.details")}
                    decoding="async"
                    onError={usePlaceholder ? undefined : () => setFailedImage(imageSource)}
                  />
                  {usePlaceholder && (
                    <div className="ac-offer-detail__placeholder-caption">
                      <span className="ac-offer-detail__placeholder-mark" aria-hidden="true"><GiftOutlined /></span>
                      <span>{t("banners.title2")}</span>
                      <p>{t("offersPage.intro")}</p>
                    </div>
                  )}
                </div>
                <section className="ac-offer-detail__panel" aria-labelledby="offer-details-heading">
                  <div className="ac-offer-detail__panel-heading">
                    <span className="ac-offer-detail__icon" aria-hidden="true"><GiftOutlined /></span>
                    <h2 id="offer-details-heading">{t("offerDetail.details")}</h2>
                  </div>
                  {details ? (
                    <div className="ac-offer-detail__content" dangerouslySetInnerHTML={{ __html: details }} />
                  ) : (
                    <p className="ac-offer-detail__fallback">{t("offerDetail.noDetails")}</p>
                  )}
                  <div className="ac-offer-detail__footer">
                    <Link to="/offers" className="ac-offer-detail__back">
                      <ArrowLeftOutlined aria-hidden="true" />
                      {t("offerDetail.back")}
                    </Link>
                  </div>
                </section>
              </div>
            </article>
          ) : (
            <section className="ac-offer-detail__empty">
              <GiftOutlined aria-hidden="true" />
              <h1>{t("offerDetail.unavailable")}</h1>
              <p>{t("offerDetail.chooseOffer")}</p>
              <Link to="/offers" className="ac-offer-detail__back">
                <ArrowLeftOutlined aria-hidden="true" />{t("offerDetail.back")}
              </Link>
            </section>
          )}
        </div>
      </main>
      <Footer type="internal" />
    </>
  );
};

export default OffersDetails;
